



import Vue from 'vue';

import DocumentLibraryDetails from '@/components/DocumentLibrary/DocumentLibraryDetails.vue';

export default Vue.extend({
  name: 'DocumentLibrary',
  components: {
    DocumentLibraryDetails,
  },
});
